export default {
  data () {
    return {}
  },
  methods: {
    dbTimeToMinutes (...dbTimes) {
      return dbTimes?.reduce((acc, t) => {
        if (!t) return acc
        if (t.includes(' ')) t = t.split(' ')?.[1] ?? ''
        let time = t.toString().split(':')
        const value = parseInt(time[0] ?? '0') * 60 + parseInt(time[1] ?? 0)
        if (!isNaN(value)) acc.push(value)
        return acc
      }, []) ?? []
    },
    minutesToDisplay (minutes) {
      let [tempValue, hours] = [minutes ?? 0, 0]
      while (tempValue - 60 >= 0) tempValue -= 60, ++hours
      let ampm = hours >= 12 ? 'PM' : 'AM'
      if (hours == 0) hours = 12
      else if (hours > 12) hours -= 12
      return hours.toString() + ':' + (tempValue.toString().length < 2 ? '0' + tempValue.toString() : tempValue.toString()) + ' ' + ampm
    },
    /**
     * Convert a time definition in `minutes` to a DB readable time
     * @param {number} minutes User-selected time in minutes
     * @returns {string} DB readable time conversion
     */
    minutesToDbTime (minutes) {
      let [tempValue, hours] = [minutes, 0]
      while (tempValue - 60 >= 0) {
        ++hours
        tempValue -= 60
      }
      const hourString = `${hours < 10 ? '0' : ''}${hours}`
      const minuteString = `${tempValue < 10 ? '0' : ''}${tempValue}`
      return `${hourString}:${minuteString}:00`
    },
    /**
     * Take in the `date` value from `floorPlanData` and a selected `time` value from the TimeRadar component
     * and combine their values into the user's currently selected time
     * @param {string} date `date` value from `floorPlanData`
     * @param {string, number} time `time` value from `TimeRadar.vue`
     */
    selectedDateTime (date, time) {
      if (time) return [date.substring(0, 10), this.minutesToDbTime(time)].join(' ')
      return date
    }
  }
}
